import { useContext, useEffect, useState, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { diContainerContext } from 'application/contexts/useDiContainer';
import { BuyerUserQuery } from 'interfaceAdapter/queries/BuyerUser';
import { buyerUserContext } from 'application/contexts/useBuyerUser';
import { PROFILE_STAGE } from 'domain/entities/BuyerUser/BuyerUser';

/**
 * 認証状態の確認と、ログイン後ページの共通処理
 */
export const useBuyerStandard = () => {
    const mainRef = useRef<HTMLDivElement>(null);
    const navigate = useNavigate();
    const diContainer = useContext(diContainerContext);
    const buyerUserQuery = diContainer.resolve(BuyerUserQuery);
    const { setUser } = useContext(buyerUserContext);
    const [canEnter, setCanEnter] = useState(false);
    const [isSideOpen, setIsSideOpen] = useState(true);

    useEffect(() => {
        if (mainRef.current) {
            mainRef.current.scrollTop = 0;
        }
        const checkCanEnter = async () => {
            const { user, status } = await buyerUserQuery.checkToken(false);
            if (status !== false) {
                setUser(user);
                if (user.account_profile_stage === PROFILE_STAGE.ONLY_PASSWORD) {
                    navigate('/buyer/registration/company_profile/');
                }
                setCanEnter(true);
            } else {
                // 有効なトークンが無いのでリダイレクト
                navigate('/buyer/login/');
            }
        };
        checkCanEnter();
    }, [window.location]);

    return { mainRef, canEnter, isSideOpen, setIsSideOpen };
};
